<template>
	<simple-modal
			@close="close()"
			:display="display"
			:title="title"
	>
		<template #default>
			<div class="columns is-multiline">
				<div class="column is-6-desktop is-full-touch">
					<div class="control" >
						<div class="field">
							<label class="label required">{{ translations.fields.firstname }}</label>
							<div class="control">
								<input
										class="input"
										type="text"
										v-model="guest.firstname"
										required
										@input="checkInput('firstname')"
								>
							</div>
							<p class="help is-danger" v-if="errors.firstname">{{ errors.firstname.join(', ') }}</p>
						</div>
					</div>
				</div>
				<div class="column is-6-desktop is-full-touch">
					<div class="control" >
						<div class="field">
							<label class="label required">{{ translations.fields.lastname }}</label>
							<div class="control">
								<input
										class="input"
										type="text"
										v-model="guest.lastname"
										required
										@input="checkInput('lastname')"
								>
							</div>
							<p class="help is-danger" v-if="errors.lastname">{{ errors.lastname.join(', ') }}</p>
						</div>
					</div>
				</div>

				<div class="column is-6-desktop is-full-touch">
					<div class="control" >
						<div class="field">
							<label class="label required">{{ translations.fields.company }}</label>
							<div class="control">
								<input
										class="input"
										type="text"
										v-model="guest.company"
										required
										@input="checkInput('company')"
								>
							</div>
							<p class="help is-danger" v-if="errors.company">{{ errors.company.join(', ') }}</p>
						</div>
					</div>
				</div>
				<div class="column is-6-desktop is-full-touch">
					<div class="control" >
						<div class="field">
							<label class="label required">{{ translations.fields.language }}</label>
							<div class="select is-fullwidth">
								<select v-model="guest.language" required>
									<option v-for="language in languages" :value="language" :key="language">
										{{ language.substring(0,2) }}
									</option>
								</select>
							</div>
							<p class="help is-danger" v-if="errors.language">{{ errors.language.join(', ') }}</p>
						</div>
					</div>
				</div>

				<div class="column is-6-desktop is-full-touch">
					<div class="control" >
						<div class="field">
							<label class="label required">{{ translations.fields.email }}</label>
							<div class="control">
								<input
										class="input"
										type="text"
										v-model="guest.email"
										required
										@input="checkInput('email')"
								>
							</div>
							<p class="help is-danger" v-if="errors.email">{{ errors.email.join(', ') }}</p>
						</div>
					</div>
				</div>
				<div class="column is-6-desktop is-full-touch">
					<div class="control" >
						<div class="field">
							<label class="label required">{{ translations.fields.amount }}</label>
							<div class="control has-icons-right">
								<input
										class="input"
										type="number"
										min="0"
										max="250"
										v-model="guest.amount"
										required
										@input="checkInput('amount')"
								>
								<span class="icon is-right">€</span>
							</div>
							<p class="help is-danger" v-if="errors.amount">{{ errors.amount.join(', ') }}</p>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template #footer>
			<div class="container is-fullwidth">
				<div class="is-flex is-justify-content-space-between">
					<button :disabled="!canSubmit" @click="submitAndClean" class="button" :class="{'is-loading': loading.addAndContinue }">{{ translations.buttons.add_and_continue }}</button>
					<div>
						<button class="button" @click="close">{{ translations.buttons.cancel }}</button>
						<button type="submit" :disabled="!canSubmit" @click="closeAndSubmit" class="button is-emv" :class="{'is-loading': loading.continue }">{{ translations.buttons.save }}</button>
					</div>
				</div>
			</div>
		</template>
	</simple-modal>
</template>

<script>
import {ApiMonizze} from "../../api-monizze";

export default {
	data: function()
	{
		return {
			guest: {
				firstname: '',
				lastname: '',
				company: '',
				language: '',
				email: '',
				amount: '250',
			},
			title: this.$props.translations.add_title,
			errors: {},
			loading: {
				addAndContinue: false,
				continue: false
			},
			userId: null
		}
	},
	props: {
		display: {
			type: Boolean,
			required: true,
		},
		translations : {
			type: Object,
			required: false
		},
		languages: {
			type: Array,
			required: true,
		},
		urls: {
			type: Object,
			required: true,
		},
	},
	methods: {
		close: function()
		{
			this.guest = {
				firstname: '',
				lastname: '',
				company: '',
				language: '',
				email: '',
				amount: '250',
			}
			this.errors = {};

			this.$emit('close');
		},
		checkInput: function(field)
		{
			if (field === 'email')
			{
				if (/^\w+([-+\.]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(this.guest[field]))
				{
					if (this.errors.hasOwnProperty(field))
					{
						delete this.errors[field];
						this.errors = { ...this.errors };
					}
				} else {
					const errorMessage = this.translations.fields.errors.email;
					this.errors = {
						...this.errors,
						[field]: [errorMessage]
					};
				}
			}
			else if (field === 'amount')
			{
				let amount = this.guest[field];
				if (this.errors.hasOwnProperty(field)) {
					delete this.errors[field];
					this.errors = { ...this.errors };
				}
				if (this.guest[field] == '')
				{
					const errorMessage = this.translations.fields.errors.required.replace(':attribute', field)
							.replace(field, this.translations.fields[field]);
					this.errors = {
						...this.errors,
						[field]: [errorMessage]
					};
				}
				else if (amount > 250 || amount < 0)
				{
					const errorMessage = this.translations.fields.errors.amount;
					this.errors = {
						...this.errors,
						[field]: [errorMessage]
					};
				}
			}
			else
			{
				if (this.guest[field] != '' ) {
					if (this.errors.hasOwnProperty(field)) {
						delete this.errors[field];
						this.errors = { ...this.errors };
					}
				} else {
					const errorMessage = this.translations.fields.errors.required.replace(':attribute', field)
							.replace(field, this.translations.fields[field])
					this.errors = {
						...this.errors,
						[field]: [errorMessage]
					};
				}
			}
		},
		closeAndSubmit: async function()
		{
			this.loading.continue = true;
			let hasErrors = await this.validateGuest();

			if (!hasErrors)
			{
				await this.save();
				this.loading.continue = false;
				this.close();
			}
			this.loading.continue = false;
		},
		submitAndClean: async function()
		{
			this.loading.addAndContinue = true;
			let hasErrors = await this.validateGuest();

			if (!hasErrors)
			{
				await this.save();
			}
			this.loading.addAndContinue = false;
		},
		save: async function()
		{
			let saveUrl = this.urls.save;
			let extraOrderLineUrl = this.urls.add_extra_order_line
			let _this = this;

			await axios.post(
					saveUrl,
					_this.guest,
					(new ApiMonizze())._defaultAxiosConfig()
			).then(response => {
				let data = response.data.data;
				_this.userId = data.user_id;
			}).catch(error => {
				this.loading.continue = false;
				this.loading.addAndContinue = false;
			});

			if (_this.userId)
			{
				await axios.post(
						extraOrderLineUrl,
						{
							user_id: _this.userId,
							facevalue: _this.guest.amount * 100
						},
						(new ApiMonizze()._defaultAxiosConfig())
				).catch(error => {
					this.loading.continue = false;
					this.loading.addAndContinue = false;
				});

				this.guest = {
					firstname: '',
					lastname: '',
					company: '',
					language: '',
					email: '',
					amount: '250',
				};
				_this.$emit('new-guest')
			}

			_this.useId = null;
		},
		validateGuest: async function ()
		{
			let validationUrl = this.urls.validate;
			let _this = this;
			let hasError = false;

			await axios.post(
					validationUrl,
					_this.guest,
					(new ApiMonizze())._defaultAxiosConfig()
			).then(data => {
				let response = data.data;
				_this.errors = {};

				if (response.already_in_customer == true)
				{
					if (this.guest['email'] != '' ) {
						if (this.errors.hasOwnProperty('email')) {
							delete this.errors['email'];
							this.errors = { ...this.errors };
						}
					} else {
						const errorMessage = this.translations.fields.errors.already_exist;
						this.errors = {
							...this.errors,
							['email']: [errorMessage]
						};
					}
					hasError = true;
				}

				return hasError;
			}).catch(error => {
				this.loading.continue = false;
				this.loading.addAndContinue = false;
			});
		},
	},
	computed: {
		canSubmit: function()
		{
			return !this.hasErrors
				&& this.guest.firstname !== ''
				&& this.guest.lastname !== ''
				&& this.guest.company !== ''
				&& this.guest.language !== ''
				&& this.guest.email !== ''
				&& this.loading.addAndContinue === false
				&& this.loading.continue === false
		},
		hasErrors : function ()
		{
			return Object.values(this.errors)
					.some(errorArray => errorArray && errorArray.length > 0);
		},
	}
}
</script>

<style>
	.modal-card-body {
		min-height: 280px !important;
	}
</style>
